export function CityImageWithDefault({
  fullSrc,
  fullDef,
  ext = "jpg",
  src,
  defSrc,
  alt,
  isSrcError,
  onError,
  ...props
}) {
  return isSrcError ? (
    <img
      {...props}
      onError={() => onError("default")}
      alt={alt}
      src={
        fullDef ||
        `https://${window.SERVER_DATA.REACT_APP_BUCKET_NAME}.` +
          `${window.SERVER_DATA.REACT_APP_BUCKET_PATH}/cities/` +
          `${defSrc}.${ext}`
      }
    />
  ) : (
    <img
      {...props}
      onError={() => onError("original")}
      alt={alt}
      data-src={
        fullSrc ||
        `https://${window.SERVER_DATA.REACT_APP_BUCKET_NAME}.` +
          `${window.SERVER_DATA.REACT_APP_BUCKET_PATH}/cities/` +
          `${src}.${ext}`
      }
    />
  );
}
